<template>
  <div>
    <Head :title="purchaseOrder.code" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/purchaseorders">
        Purchase Orders
      </Link>
      <span class="text-indigo-400 font-medium"> / </span>
      {{ purchaseOrder.code }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input
            :model-value="form.purchase_request_no"
            class="pb-8 pr-6 w-full md:w-1/2"
            input-class="bg-gray-200"
            label="Project"
            disabled />
          <select-input
            v-model="form.organization_id"
            :error="form.errors.organization_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Supplier"
            :disabled="disabledInput">
            <option
              v-for="organization in organizations"
              :key="organization.id"
              :value="organization.id">
              {{ organization.name }}
            </option>
          </select-input>
          <text-input
            :model-value="purchaseReqInfo.projectName"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Project"
            disabled />
          <text-input
            :model-value="purchaseReqInfo.activity"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="PR Activity"
            disabled />
          <select-input
            v-if="purchaseOrder.status === 'CREATED'"
            v-model="form.status"
            :error="form.errors.status"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Status">
            <option value="CREATED">
              CREATED
            </option>
            <option value="ON-PROCESS">
              ON-PROCESS
            </option>
          </select-input>
          <text-input
            v-else
            input-class="font-bold text-center"
            :model-value="purchaseOrder.status"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Status"
            disabled />
          <text-input
            :model-value="formatDate(form.po_date)"
            :error="form.errors.po_date"
            input-class="text-center"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="PO Date"
            disabled />
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Description"
            :disabled="disabledInput" />
          <text-input
            :model-value="form.operator"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Operator"
            readonly />
          <div class="w-full" />
          <select-input
            v-model="form.signature01_id"
            :error="form.errors.signature01_id"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="Menyetujui"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.signature02_id"
            :error="form.errors.signature02_id"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="Mengetahui"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.signature03_id"
            :error="form.errors.signature03_id"
            class="pb-8 pr-6 w-1/2 md:w-1/3"
            label="Diajukan"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <select-input
            v-model="form.signature04_id"
            :error="form.errors.signature04_id"
            class="pb-8 pr-6 w-1/2 md:w-1/2"
            label="Direktur"
            :disabled="disabledInput">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.signature05_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            :error="form.errors.signature05_id"
            label="Vendor"
            :disabled="disabledInput" />
          <text-input
            v-model="form.pembayaran"
            class="pb-8 pr-6 w-full md:w-1/2"
            :error="form.errors.pembayaran"
            label="Pembayaran"
            :disabled="disabledInput" />
          <text-input
            v-model="form.pengiriman"
            class="pb-8 pr-6 w-full md:w-1/2"
            :error="form.errors.pengiriman"
            label="Pengiriman"
            :disabled="disabledInput" />
          <number-input
            :model-value="purchaseOrder.total"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Total"
            readonly />
          <number-input
            :model-value="purchaseOrder.total_recv"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Total Recv"
            readonly />
        </div>

        <div class="-mr-6 px-8 py-4 border-t border-gray-100" id="attachments">
          <h3 class="text-xl">
            List berkas pendukung:
          </h3>

          <ul
            v-for="(docfile, idx) in purchaseOrder.files"
            :key="idx"
            class="w-full list-disc">
            <li class="flex gap-2 items-center">
              <span>- </span>
              <a
                :href="docfile.url"
                :class="attachmentAccess.download ? 'text-indigo-500 underline' : 'text-red-600'"
                target="_blank"
                :download="docfile.file_name"
                :disable="!attachmentAccess.download"> {{ docfile.file_name }}</a> ( {{ docfile.size }} )
              <a
                href=""
                title="Delete attachment file"
                @click.prevent="destroyAttachment(docfile.uuid)">
                <Icon icon="ic:baseline-delete-forever" class="w-6 h-6 text-red-600" />
              </a>
            </li>
          </ul>

          <file-input
            v-model="form.attachment"
            :error="form.errors.attachment"
            class="pr-6 py-4 w-full md:w-2/3"
            type="file"
            accept="image/*, application/pdf"
            label="Browse dan upload file dokumen pendukung (Max 10MB)"
            @update:model-value="uploadAttachment"
            v-if="attachmentAccess.upload" />
        </div>

        <div class="flex px-8 py-4 bg-gray-50 border-t border-gray-100">
          <template v-if="purchaseOrder.status === 'CREATED'">
            <button
              class="text-red-600 hover:underline"
              type="button"
              @click="destroy">
              Delete Purchase Order
            </button>
            <loading-button
              :loading="form.processing"
              class="btn-indigo ml-auto"
              type="submit">
              Update Purchase Order
            </loading-button>
          </template>
          <template v-else>
            <a
              :href="`/purchaseorders/${purchaseOrder.id}/print`"
              as="button"
              target="_blank"
              class="ml-auto px-6 py-3 text-white whitespace-nowrap text-sm font-bold leading-4 focus:bg-green-400 bg-green-500 hover:bg-orange-400 rounded"> Print PO (PDF) </a>
            <Link
              v-if="purchaseOrder.status !== 'CREATED'"
              :href="`/porecv`"
              as="button"
              class="ml-auto px-6 py-3 text-white whitespace-nowrap text-sm font-bold leading-4 hover:bg-orange-400 focus:bg-orange-400 bg-yellow-500 rounded">
              Penerimaan PO
            </Link>
          </template>
        </div>
      </form>
    </div>
    <h2 class="mt-12 text-2xl font-bold">
      Details
    </h2>
    <detail-flash-messages />
    <div class="flex justify-between my-5">
      <button
        v-if="enableCreate"
        class="btn-indigo"
        @click="createDetail">
        <span>Create</span> <span class="hidden md:inline">&nbsp;Detail</span>
      </button>
    </div>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="font-bold">
            <th class="align-middle px-2 text-center border-r">
              No.
            </th>
            <th class="pb-4 pt-6 px-6 w-3/12 text-left">
              Nama Barang
            </th>
            <th class="pb-4 pt-6 px-6 w-1/12 text-left">
              Satuan
            </th>
            <th class="pb-4 pt-6 px-6 w-1/12 text-right">
              Jumlah
            </th>
            <th class="pb-4 pt-6 px-6 w-2/12 text-right">
              Diterima
            </th>
            <th class="pb-4 pt-6 px-6 w-2/12 text-right">
              Harga
            </th>
            <th class="pb-4 pt-6 px-6 w-2/12 text-right">
              Total Harga
            </th>
          </tr>
        </thead>
        <tbody>
          <detail
            v-for="(orderDetail, idx) in purchaseOrderDetails.data"
            :key="orderDetail.id"
            :editable-mode="orderDetail.editable"
            :order-detail="orderDetail"
            :items="items"
            :errors="$page.props.errors"
            :row-index="++idx"
            :disabled="purchaseOrder.status !== 'CREATED'"
            :current-page="purchaseOrderDetails.current_page"
            :per-page="purchaseOrderDetails.per_page"
            @destroy:detail="destroyDetail"
            @edit:detail="editDetail"
            @cancel="cancel('edit')"
            @save="updateDetail" />
          <tr v-if="purchaseOrderDetails.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="7">
              No details found.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="purchaseOrderDetails.links" />
  </div>
</template>

<script lang="js">
import { Head, Link, router } from '@inertiajs/vue3'
import FileInput from '@/Shared/FileInput'
import { Icon } from '@iconify/vue'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import { format, parse } from 'date-fns'
import NumberInput from '@/Shared/NumberInput'
import Detail from '@/Pages/PurchaseOrders/DetailRow'
import DetailFlashMessages from '@/Shared/DetailFlashMessages'
import Pagination from '@/Shared/Pagination'
import find from 'lodash/find'

export default {
    components: {
        Head,
        Icon,
        Link,
        FileInput,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
        NumberInput,
        Detail,
        DetailFlashMessages,
        Pagination,
    },
    layout: Layout,
    props: {
        purchaseOrder: Object,
        purchaseOrderDetails: Object,
        organizations: Object,
        items: Object,
        purchaseRequestDetailCount: Number,
        employees: Object,
        attachmentAccess: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                organization_id: this.purchaseOrder.organization_id,
                purchase_request_id: this.purchaseOrder.purchase_request_id,
                purchase_request_no: this.purchaseOrder.purchase_request_no,
                code: this.purchaseOrder.code,
                status: this.purchaseOrder.status,
                po_date: this.purchaseOrder.po_date,
                operator: this.purchaseOrder.operator,
                description: this.purchaseOrder.description,
                signature01_id: this.purchaseOrder.signature01_id,
                signature02_id: this.purchaseOrder.signature02_id,
                signature03_id: this.purchaseOrder.signature03_id,
                signature04_id: this.purchaseOrder.signature04_id,
                signature05_id: this.purchaseOrder.signature05_id,
                pembayaran: this.purchaseOrder.pembayaran,
                pengiriman: this.purchaseOrder.pengiriman,
                attachment: null,
            }),
            purchaseReqInfo: {
                projectName: null,
                activity: null,
            },
            editedItem: {
                id: null,
                item: null,
                qty: null,
                qty_recv: null,
                price: null,
                deleted_at: null,
                editable: false,
            },
            detailKeyRefresh: 0,
        }
    },
    computed: {
        disabledInput () {
            return this.purchaseOrder.status !== 'CREATED'
        },
        disableSelectPurchaseRequest () {
            return this.disabledInput || (this.purchaseOrderDetails.data.length > 0)
        },
        enableCreate () {
            return this.purchaseOrder.status === 'CREATED' && (this.purchaseRequestDetailCount > this.purchaseOrderDetails.data.length)
        },
    },
    watch: {
        'form.purchase_request_id' (newVal) {
            this.projectActivityByPR(newVal)
        },
    },
    mounted () {
        this.projectActivityByPR(this.form.purchase_request_id)
    },
    //TODO: cegah tambah qty barang melebihi qty total di PR
    methods: {
        update () {
            this.form.post(`/purchaseorders/${this.purchaseOrder.id}`, {
                preserveScroll: true,
                onSuccess: () => this.form.reset('attachment'),
            })
        },
        destroy () {
            router.delete(`/purchaseorders/${this.purchaseOrder.id}`, {
                onBefore: () => confirm('Are you sure you want to delete this purchase request?'),
            })
        },
        uploadAttachment () {
            this.form.attachment && this.update()
        },
        destroyAttachment (uuid) {
            router.delete(`/attachment/${uuid}`, {
                preserveScroll: true,
                onBefore: () => confirm('Are you sure you want to delete this attachment file?'),
            })
        },
        restore () {
            if (confirm('Are you sure you want to restore this purchase request?')) {
                this.$inertia.put(`/purchaseorders/${this.purchaseOrder.id}/restore`)
            }
        },
        projectActivityByPR (prId) {
            fetch(`/projectactivity?pr=${prId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    this.purchaseReqInfo.projectName = data.data.project
                    this.purchaseReqInfo.activity = data.data.pr_activity
                })
        },
        formatDate (ymd) {
            return format(parse(ymd, 'yyyy-MM-dd', new Date()), 'dd-MMM-yyyy')
        },
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        editDetail (detail) {
            let edited = find(this.purchaseOrderDetails.data, ['id', detail.id])
            edited.editable = true
        },
        destroyDetail (detailId) {
            router.delete(`/purchaseordersdetails/${detailId}`, {
                preserveScroll: true,
            })
        },
        resetEditedItem () {
            this.editedItem = {
                id: null,
                item_id: null,
                qty: 0,
                qty_recv: 0,
                price: 0,
                editable: false,
            }
        },
        cancel (action) {
            if (action === 'create')
                this.resetEditedItem()
            if (action === 'edit')
                this.$inertia.reload({ only: ['purchaseOrderDetails'] })
        },
        createDetail (value) {
            const formDetail = this.$inertia.form({
                purchase_order_m_id: this.purchaseOrder.id,
            })
            formDetail.post('/purchaseordersdetails', {
                preserveScroll: true,
                onSuccess: () => {
                    this.resetEditedItem()
                },
                onError: () => {
                    this.editedItem = value
                },
            })
        },
        updateDetail (value) {
            const formDetail = this.$inertia.form({
                item_id: value.item_id,
                qty: value.qty,
                qty_recv: value.qty_recv,
                price: value.price,
                item_unit_id: value.item_unit_id,
            })
            formDetail.put(`/purchaseordersdetails/${value.id}`, {
                preserveScroll: true,
                onError: () => {
                    this.editedItem = value
                    let edited = find(this.purchaseOrderDetails.data, ['id', value.id])
                    if (edited) {
                        edited.editable = true
                    }
                },
            })
        },
    },
}
</script>
